import { v4 as uuidv4 } from 'uuid';

const uid = function () {
    return uuidv4()
}

export default  uid